import { faker } from "@faker-js/faker/locale/fr"
import type { SourceName } from "../../../types"
import type {
  ApiFinancialDataPurchasesSummary,
  ApiPurchasesSummary,
} from "../../purchases"

export const purchasesMock = (): ApiPurchasesSummary => {
  const {
    number: { int },
    date,
    commerce: { productName },
  } = faker
  const num = (min = -999_999, max = 999_999) => int({ min, max })
  const fakeDate = () => date.anytime().toISOString()

  const mockPurchaseSummary = () => ({
    purchases: {
      mainStat: num(),
      evolution: num(0, 100),
    },
    discounts: {
      total: num(),
      percentage: num(0, 100),
    },
    periodStartDate: fakeDate(),
    periodEndDate: fakeDate(),
    sources: faker.helpers.multiple(() => productName() as SourceName, {
      count: { min: 1, max: 3 },
    }),
  })

  return {
    ...mockPurchaseSummary(),
    main: {
      ...mockPurchaseSummary(),
      channels: [
        { name: "CERP ROUEN", ...mockPurchaseSummary() },
        { name: "COALIA", ...mockPurchaseSummary() },
        { name: "DIRECT", ...mockPurchaseSummary() },
        { name: "SAGITTA", ...mockPurchaseSummary() },
        { name: "PHARMAT", ...mockPurchaseSummary() },
      ],
    },
    other: {
      ...mockPurchaseSummary(),
      channels: [
        { name: "REPARTITION", ...mockPurchaseSummary() },
        { name: "RETROCESSION", ...mockPurchaseSummary() },
        { name: "ALLIANCE HR", ...mockPurchaseSummary() },
        { name: "VETO SANTE", ...mockPurchaseSummary() },
      ],
    },
  }
}

export const purchasesSummaryMock = (): ApiFinancialDataPurchasesSummary => ({
  purchases: {
    mainStat: faker.number.float({ min: 0, max: 9_999_999, fractionDigits: 2 }),
    evolution: faker.number.float({ min: -100, max: 100, fractionDigits: 1 }),
  },
})
